/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "../../../../component/button";
import classes from "../checkout.module.css";
import { useEffect } from "react";
import Input from "../../../../component/inputpm";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../../component/breadcrumb";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { useNavigate } from "react-router-dom";

const OrderNotes = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const [notes, setNotes] = useState("");
  const [agentId, setAgentId] = useState("");
  const [priceNotes, setPriceNotes] = useState("");
  const [externalId, setExternalId] = useState("");
  const [bread, setBread] = useState([
    {
      title: `${props.t("CHECKOUT")}: ${props.t("ORDER_NOTES")}`,
      url: "/checkout",
    },
  ]);

  const [shipmentMethodTypeId, setShipmentMethodTypeId] = useState(
    "ST_OVERNIGHT | FEDEX",
  );
  const [shipmentMethodTypeList, setShipmentMethodTypeList] = useState([
    {
      name: "Federal Express - Standard Overnight",
      value: "ST_OVERNIGHT | FEDEX",
    },
    // , {
    //     name: 'Federal Express - International Priority',
    //     value: 'INTERNAT_PRI | FEDEX'
    // }, {
    //     name: 'Federal Express - International Economy',
    //     value: 'INTERNAT_ECON | FEDEX'
    // }, {
    //     name: 'Federal Express - Europe First Priority',
    //     value: 'EUROPE_FI_PRIORITY | FEDEX'
    // }, {
    //     name: 'Federal Express - Fedex International Ground',
    //     value: 'FEDEX_INT_GROUND | FEDEX'
    // }, {
    //     name: 'Federal Express - Next Morning',
    //     value: 'NEXT_AM | FEDEX'
    // }, {
    //     name: 'Federal Express - Same Day',
    //     value: 'SAME_DAY | FEDEX'
    // }, {
    //     name: 'Federal Express - Guaranteed Next Day',
    //     value: 'NEXT_DAY | FEDEX'
    // }, {
    //     name: 'UPS - Standard',
    //     value: 'UPS - STANDARD | UPS'
    // }, {
    //     name: 'UPS - Worldwide ExpressSM',
    //     value: 'WORLDWIDE_EXPRESS | UPS'
    // }, {
    //     name: 'UPS - Worldwide ExpeditedSM',
    //     value: 'WORLDWIDE_EXPEDITED | UPS'
    // }, {
    //     name: 'DHL - International Express',
    //     value: 'INT_EXPRESS | DHL'
    // }, {
    //     name: 'DHL - Express',
    //     value: 'EXPRESS | DHL'
    // }, {
    //     name: 'DHL - Second Day',
    //     value: 'SECOND_DAY | DHL'
    // }
  ]);
  const inputAlphaNumeric = (e, callback) => {
    if (e.target.value.length < 21) {
      const value = e.target.value
        ? e.target.value.replace(/[^0-9a-zA-Z -]+/gi, "")
        : "";
      if (e.target.value !== value) {
        e.target.value = value;
      }
      if (typeof callback === "function") {
        return callback(value);
      }
    }
  };
  useEffect(() => {
    if (props.edit) {
      setNotes(props.notes.notes);
      setPriceNotes(props.notes.priceNotes);
      setAgentId(props.notes.agentId ? props.notes.agentId : "");
      setShipmentMethodTypeId(
        props.notes.setShipmentMethodTypeId
          ? props.notes.setShipmentMethodTypeId
          : "ST_OVERNIGHT | FEDEX",
      );
      setExternalId(props.notes.externalId ? props.notes.externalId : "");
    } else {
      setShipmentMethodTypeId("ST_OVERNIGHT | FEDEX");
    }
  }, []);
  // const sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
  const sideMenu = props.sideMenu;
  var preSelectedCustomer = JSON.parse(
    localStorage.getItem("preSelectedCustomer"),
  );
  return (
    <React.Fragment>
      <div className={"newContentWrapper checkPageContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={bread} />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <Grid
        container
        spacing={3}
        style={{ marginTop: sideMenu ? "25px" : "65px" }}
      >
        {/* <h2 className={classes.checkoutTitle}> {`Checkout: ${t('ORDER_NOTES')}`}</h2> */}
        {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
          props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
          <>
            {sideMenu ? (
              <></>
            ) : (
              <Grid
                item
                size={{
                  xs: 2,
                }}
              ></Grid>
            )}
            <Grid
              item
              size={{
                xs: sideMenu ? 6 : 4,
              }}
            >
              <Input
                variant={"outlined"}
                size={"small"}
                inputClass={classes.notesInput}
                name={"agentId"}
                placeholder={t("AGENT_ID")}
                value={agentId}
                onChange={(e) => {
                  setAgentId(e.target.value);
                }}
                autoComplete="on"
              />
            </Grid>
            <Grid
              item
              size={{
                xs: sideMenu ? 6 : 4,
              }}
            >
              <Input
                variant={"outlined"}
                size={"small"}
                inputClass={classes.notesInput}
                name={"externalId"}
                placeholder={t("CUSTOMER_ORDER_NUMBER")}
                value={externalId}
                // onChange={(e) => {  }}
                onChange={(e) =>
                  inputAlphaNumeric(e, (value) => {
                    setExternalId(e.target.value);
                  })
                }
                autoComplete="on"
              />
            </Grid>
            {sideMenu ? (
              <></>
            ) : (
              <Grid
                item
                size={{
                  xs: 2,
                }}
              ></Grid>
            )}
          </>
        )}

        {sideMenu ? (
          <></>
        ) : (
          <Grid
            item
            size={{
              xs: 2,
            }}
          ></Grid>
        )}
        <Grid
          item
          size={{
            xs: sideMenu ? 12 : 8,
          }}
        >
          <FormControl
            variant="outlined"
            size={"small"}
          >
            <InputLabel id="shipping-method-label">
              {t("SHIPPING_METHOD")} *
            </InputLabel>
            <Select
              native
              labelId="shipping-method-label"
              label={t("SHIPPING_METHOD") + " *"}
              value={shipmentMethodTypeId}
              onChange={(e) => {
                setShipmentMethodTypeId(e.target.value);
              }}
              inputProps={{
                name: "facilityId",
                id: "outlined-age-native-simple",
              }}
            >
              {shipmentMethodTypeList.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.name}
                </option>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {sideMenu ? (
          <></>
        ) : (
          <Grid
            item
            size={{
              xs: 2,
            }}
          ></Grid>
        )}

        {sideMenu ? (
          <></>
        ) : (
          <Grid
            item
            size={{
              xs: 2,
            }}
          ></Grid>
        )}
        <Grid
          item
          size={{
            xs: sideMenu ? 12 : 8,
          }}
        >
          <Input
            size={"small"}
            name={"notes"}
            variant={"outlined"}
            placeholder={t("NOTES") + "......."}
            //label={props.t('NOTES')}
            value={notes}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
            inputProps={{ multiline: true, rows: 5, cols: 10 }}
          />
        </Grid>
        {sideMenu ? (
          <></>
        ) : (
          <Grid
            item
            size={{
              xs: 2,
            }}
          ></Grid>
        )}

        {sideMenu ? (
          <></>
        ) : (
          <Grid
            item
            size={{
              xs: 2,
            }}
          ></Grid>
        )}
        <Grid
          item
          size={{
            xs: sideMenu ? 12 : 8,
          }}
        >
          <div className={classes.stepButton}>
            {preSelectedCustomer && preSelectedCustomer.accountName ? (
              <>
                {props.edit ? (
                  <Button
                    onClick={() => {
                      props.back(props.stage);
                    }}
                  >
                    {props.edit ? t("CANCEL") : t("BACK")}
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      navigate("/cart");
                    }}
                  >
                    {t("BACK")}
                  </Button>
                )}
              </>
            ) : (
              <Button
                onClick={() => {
                  props.back(props.stage);
                }}
              >
                {props.edit ? t("CANCEL") : t("BACK")}
              </Button>
            )}
            <Button
              onClick={() => {
                props.next(props.stage, {
                  notes,
                  priceNotes,
                  agentId,
                  shipmentMethodTypeId,
                  externalId,
                });
              }}
            >
              {props.edit ? t("UPDATE") : t("NEXT")}
            </Button>
          </div>
        </Grid>
        {sideMenu ? (
          <></>
        ) : (
          <Grid
            item
            size={{
              xs: 2,
            }}
          ></Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default withTranslation("translations")(OrderNotes);
